import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const CustomerContext = createContext();

export const CustomerProvider = ({ children }) => {
    const [customers, setCustomers] = useState([]);
    const baseUrl = process.env.REACT_APP_BASE_URL;

    const [token, setToken] = useState(() => localStorage.getItem("token"));

    useEffect(() => {
        const syncAuth = () => {
            setToken(localStorage.getItem("token"));
        };

        window.addEventListener("authChanged", syncAuth);
        return () => window.removeEventListener("authChanged", syncAuth);
    }, []);

    const fetchCustomers = async () => {
        if (!baseUrl || !token) return;

        try {
            const res = await axios.get(`${baseUrl}/get-customers`);
            setCustomers(res.data.customers || []);
        } catch (err) {
            console.error("Failed to fetch customers", err);
            toast.error("Failed to load customer list");
        }
    };

    useEffect(() => {
        fetchCustomers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [baseUrl, token]);

    const addCustomers = async (batch) => {
        try {
            const res = await axios.post(`${baseUrl}/add-customers`, batch);

            toast.success("Customer(s) added successfully!");

            await fetchCustomers();

            return res.data;
        } catch (err) {
            console.error("Failed to add customers", err);
            toast.error("Error adding customers");
            throw err;
        }
    };

    return (
        <CustomerContext.Provider
            value={{
                customers,
                setCustomers,
                addCustomers,
                fetchCustomers,
            }}
        >
            {children}
        </CustomerContext.Provider>
    );
};

export const useCustomers = () => useContext(CustomerContext);
